<template>
  <div v-show="isCardActiveLocal">>
    <div class="clickpagequizviewer">
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <div v-html="question.questionText"></div>
        </div>
      </div>
    </div>

    <div class="overflow-draggable-div">
      <div :style="{height: (100 * scale) + 10 + 'px', width: (100 * scale) + 10 + 'px', margin: 0 + 'px !important'}" v-for="(item, index) in question.dragAndDropMapLocations" :key="index">
          <img
            :id="'draggableimagediv_' + index"
            :style="{ width: 100 * scale + 'px', height: 100 * scale + 'px', overflow: 'visible'} " 
            :src="item.draggableImageUrl">
      </div>
    </div>

    <vs-divider style="padding-top: 10px"></vs-divider>

    <div class="canvas-div-drag-and-drop">
      <canvas 
        id="studentCanvas" 
        ref="studentCanvasRef"
        :width="canvasWidth" 
        :height="canvasHeight" 
        :style="canvasBackgroundStyle"
        class="student-canvas-background"
        >
      </canvas>
    </div>
  </div>

</template>

<script>
  import Draggable from '@/views/coursebuilder/draggable.js';

  export default {
    components: {

    },
    data() {
      return {
        originalImageLocations: {},
        canvasHeight: '',
        canvasWidth: '',
        scale: 0,
        windowWidth: window.innerWidth,
        fixWidth: false,
        canvasStyle: '',
        canvasBackgroundStyle: '',
        imageDivStyling: "img { height: (100 * scale) + 'px'; width: (100 * scale) + 'px'; overflow:  overflow: 'visible';}",
        runOnlyOnce: false,
      }
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
      runInit: {
        type: Boolean,
        required: false
      },
      index: {
        type: Number,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.$emit("initValues");
        }
      },
      runInit: function() {
        this.resetCanvas();
      },
      windowHeight(newHeight, oldHeight) {
        this.setScale();
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          if(this.index == 0){
            if(!this.runOnlyOnce){
              this.runOnlyOnce = true;
              this.resetCanvas();
            }
          }

          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
    },
    methods: {
      showBlocksOnCanvas(){
        var self = this;

        var canvas = document.getElementById("studentCanvas");

        var ctx = canvas.getContext("2d");

        self.question.dragAndDropMapLocations.forEach(element => {
          ctx.strokeStyle = element.color;
          ctx.strokeRect(parseInt(element.xCoordinate * self.scale), parseInt(element.yCoordinate * self.scale), parseInt(100 * self.scale) , parseInt(100 * self.scale));
          ctx.stroke();
        });

        if(self.isMobile()){
          self.canvasBackgroundStyle = { background: 'url(' + self.question.imageUrl + ')', width: '200%' };
        } else {
          self.canvasBackgroundStyle = { background: 'url(' + self.question.imageUrl + ')' };
        }
      },
      makeImagesDraggable(){
        var self = this;

        window.d = [];

        self.question.dragAndDropMapLocations.forEach(function arrayToImage(element, index){
          var localElement = document.getElementById('draggableimagediv_' + index);
        
          var options = {
            onDragEnd: self.onDragEndFunction(self),
            onDragStart:  self.onDragStartFunction(self),
            setCursor: true
          };

          window.d[index] = new Draggable (localElement, options);

          document.getElementById('draggableimagediv_' + index).style["position"] = "relative";
          document.getElementById('draggableimagediv_' + index).style["inset"] = "unset";

          document.getElementById('draggableimagediv_' + index).style["top"] = "0px";
          document.getElementById('draggableimagediv_' + index).style["bottom"] = "unset";
          document.getElementById('draggableimagediv_' + index).style["left"] = "unset";
          document.getElementById('draggableimagediv_' + index).style["right"] = "unset";
        });
      },
      onDragStartFunction (myself) {
        return function (element, x, y) {
          element.style["position"] = "absolute";
        };
      },
      resetCanvas(){
        var self = this;

        self.scale = 0;

        if(!self.isMobile()){
          self.canvasHeight = self.question.imageUrlWidth + 'px';
          self.canvasWidth = self.question.imageUrlWidth + 'px';
          self.scale = 1;
          setTimeout(() => {
            self.makeImagesDraggable();
            setTimeout(() => {
              self.showBlocksOnCanvas();
              self.setAnswers();
            }, 70);
          }, 69);
        } else {
          setTimeout(() => {
            self.canvasBackgroundStyle = "";

            self.canvasHeight = 150 + 'px';
            self.canvasWidth = 300 + 'px';

            setTimeout(() => {
              self.makeImagesDraggable();
            }, 70);
            setTimeout(() => {
              self.setScale();
              self.showBlocksOnCanvas();
            }, 100);
            setTimeout(() => {
              self.setScale();
            }, 120);
            setTimeout(() => {
              self.setAnswers();
            }, 140);
          }, 60);
        }

        window.addEventListener('resize', this.onResize);
      },
      onDragEndFunction (myself) {
        return function (element, x, y) {

          const between = (x, min, max) => {
            return x >= min && x <= max;
          }

          var imageNumber = element.id.substring(18, element.id.length);

          var xCo = x - myself.$refs.studentCanvasRef.offsetLeft;
          var yCo = y - myself.$refs.studentCanvasRef.offsetTop;

          var itFits = false;

          myself.question.dragAndDropMapLocations.forEach(function arrayToImage(elementLocal, index){
            var scale = myself.scale;

            if(between(xCo, (elementLocal.xCoordinate * scale)  - 50, (elementLocal.xCoordinate * scale) + 50) 
              && between(yCo, (elementLocal.yCoordinate * scale) - 50, (elementLocal.yCoordinate * scale) + 50)){
              window.d[imageNumber].set((elementLocal.xCoordinate * scale) + myself.$refs.studentCanvasRef.offsetLeft , (elementLocal.yCoordinate * scale) + myself.$refs.studentCanvasRef.offsetTop);

              myself.question.dragAndDropMapLocations[imageNumber].selectedXCoordinate = elementLocal.xCoordinate;
              myself.question.dragAndDropMapLocations[imageNumber].selectedYCoordinate = elementLocal.yCoordinate;

              itFits = true;
              element.style["position"] = "absolute";
            }
            if(!itFits){
              myself.question.dragAndDropMapLocations[imageNumber].selectedXCoordinate = -1;
              myself.question.dragAndDropMapLocations[imageNumber].selectedYCoordinate = -1;
              element.style["position"] = "relative";
              element.style["inset"] = "unset";
              element.style["top"] = "0px";
              element.style["bottom"] = "unset";
              element.style["left"] = "unset";
              element.style["right"] = "unset";
            }
          });
        }
      },
      setScale(){
        var self = this;

        if(self.isMobile()){
          var origionalImgWidth = self.question.imageUrlWidth;

          var currentWidth = $('canvas#studentCanvas')[0].clientWidth / 2;

          self.scale = currentWidth / origionalImgWidth;
        }
      },
      onResize() {
        this.setScale();
      },
      setAnswers(){
        var self = this;

        self.question.dragAndDropMapLocations.forEach(function setImageOnRightPlace(location, index) {
          if(location.selectedXCoordinate){
            if(location.selectedXCoordinate != -1){
              document.getElementById('draggableimagediv_' + index).style["position"] = "absolute";
              window.d[index].set((location.selectedXCoordinate * self.scale) + self.$refs.studentCanvasRef.offsetLeft , (location.selectedYCoordinate * self.scale) + self.$refs.studentCanvasRef.offsetTop);
            } else {
              document.getElementById('draggableimagediv_' + index).style["position"] = "relative";
              document.getElementById('draggableimagediv_' + index).style["inset"] = "unset";
            }
          } else{
            document.getElementById('draggableimagediv_' + index).style["position"] = "relative";
            document.getElementById('draggableimagediv_' + index).style["inset"] = "unset";
          }
        });
      }
    },
  }

</script>

<style lang="scss">

.h-scroll{
  margin: 4px, 4px;
  padding: 4px;
  background-color: #08c708;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.student-canvas-background{
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.select-images-bar{
  img{
    width: 100px !important;
    height: 100px !important;
    // width: 50px;
  }
}

.select-images-bar-two{
  width: 100px !important;
  height: 100px !important;
}

.overflow-draggable-div{
  display: flex;
  overflow-x: auto;
  width: 100%;
}

</style>
